import BrigadesList from './BrigadesList'

export default BrigadesList